const SETCURRENTUSER = 'SET_CURRENT_USER'

export {
  SETCURRENTUSER
}
